import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { environment } from '../../environments/environment';
import { RabbitPublishResponse } from '../../models/rabbit/rabbit-publish-response.model';
import { Observable } from 'rxjs/internal/Observable';
import { of } from 'rxjs/internal/observable/of';
import { catchError, finalize } from 'rxjs/operators';
import { ErrorHandlingService } from '../error-handling/error-handling.service';
import { HttpHeaderConstants } from '../http-header.constant';
import { SpinnerService } from '../spinner/spinner.service';

@Injectable({
    providedIn: 'root',
})

// used to publish messages to rabbit queues
export class RabbitPublisherService {
    readonly #spinnerService = inject(SpinnerService);
    readonly #errorHandlingService = inject(ErrorHandlingService);
    readonly #http = inject(HttpClient);

    private BASE_URL: string = environment.publicApiHost + '/appcloud/actions/apps';

    // use to get specific URL for publishing for appinstances
    getPublishUrlForAppinstance(globalAppId: string, appInstanceId: number): string {
        return `${this.BASE_URL}/${globalAppId}/appinstances/${appInstanceId}`;
    }

    // use to get specific URL for publishing for installs
    getPublishUrlForInstall(globalAppId: string): string {
        return `${this.BASE_URL}/${globalAppId}/installs`;
    }

    getPublishUrlForErrorReports(globalAppId: string): string {
        return `${this.BASE_URL}/${globalAppId}/error-reports`;
    }

    // use to publish message on rabbit queue for appinstances OR installs
    publish(url: string, body: any = null, additionalHeaders: any = {}): Observable<RabbitPublishResponse> {
        this.#spinnerService.addProcess('RabbitPublisherService.publish', 'Kicking off your process...');
        const httpOptions = {
            headers: new HttpHeaders({ ...HttpHeaderConstants.defaultHeaders, ...additionalHeaders }),
        };
        if (body == null) {
            body = {};
        }
        return this.#http.post<RabbitPublishResponse>(url, body, httpOptions).pipe(
            catchError(error => {
                this.#errorHandlingService.handleHttpError(
                    error,
                    false,
                    'An error occurred while trying to run the app. Please try again later.'
                );
                return of<RabbitPublishResponse>();
            }),
            finalize(() => this.#spinnerService.completeProcess('RabbitPublisherService.publish'))
        );
    }
}
